export const appDensity = {
  headerHeight: '64px',
  sidebarRailWidth: 76,
  pagePaddingMobile: 16,
  pagePaddingDesktop: 20,
  cardPadding: 16,
  sectionGap: 16,
  controlHeight: 38
};

export const compactTypography = {
  h1: 30,
  h2: 26,
  h3: 22,
  h4: 16,
  h5: 14,
  h6: 14,
  body: 13.5,
  caption: 12,
  subtitle1: 13.5,
  subtitle2: 14,
  overline: 11
};

export const appSpacing = 8;

export const compactComponentDefaults = {
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: appDensity.cardPadding,
        '&:last-child': { paddingBottom: appDensity.cardPadding }
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: { padding: appDensity.cardPadding }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: { padding: appDensity.cardPadding }
    }
  },
  MuiFormControl: {
    defaultProps: { size: 'small' }
  },
  MuiTable: {
    defaultProps: { size: 'small' }
  },
  MuiTextField: {
    defaultProps: { size: 'small' }
  }
};
